import { Property } from "../../../../global/types";

export const RELATED_PROPERTIES_ENDPOINT = "/api/client/related-properties";
export const FEATURED_PROPERTIES_ENDPOINT = "/api/client/featured-properties";
export const SIMILAR_PROPERTIES_DISPLAY_LIMIT = 5;

export type SimilarPropertiesSource = "related" | "featured";

export function buildRelatedPropertiesParams(property: Property) {
  return {
    id: property.id,
    minimal: 1,
    latitude: property.address?.latitude,
    longitude: property.address?.longitude,
    rentValue: property.rent_value,
    iptuValue: property.iptu_value,
    condominiumValue: property.condominium_value,
  };
}

export function extractPropertiesFromApiResponse(
  payload: { data?: unknown } | undefined,
  limit = SIMILAR_PROPERTIES_DISPLAY_LIMIT
): Property[] {
  const list = payload?.data;
  if (!Array.isArray(list)) {
    return [];
  }

  return list.slice(0, limit);
}

export function resolveSimilarPropertiesRequest(
  source: SimilarPropertiesSource,
  property?: Property
): { endpoint: string; params?: ReturnType<typeof buildRelatedPropertiesParams> } {
  if (source === "featured") {
    return { endpoint: FEATURED_PROPERTIES_ENDPOINT };
  }

  if (!property) {
    throw new Error("Related properties require a loaded property");
  }

  return {
    endpoint: RELATED_PROPERTIES_ENDPOINT,
    params: buildRelatedPropertiesParams(property),
  };
}
